<template>
    <div class="indicator-box">
        <div v-if="reduce" class="reduce-icon"></div>
        <div v-if="add" class="add-icon"></div>
    </div>
</template>

<script>
    export default {
        name: "index",
        props: {
            reduce: {
                type: Boolean,
                default: false
            },
            add: {
                type: Boolean,
                default: false
            },
        }
    }
</script>

<style lang="less" scoped>
    .indicator-box {
        .reduce-icon {
            width: 24px;
            height: 24px;
            background: url("//m.360buyimg.com/img/jfs/t1/115091/5/11836/506/5f05a8b4Ef21698c7/4e7855b5b10012cc.png") no-repeat center;
            background-size: 100%;
        }
        .add-icon {
            width: 24px;
            height: 24px;
            background: url("//img11.360buyimg.com/imagetools/jfs/t1/133163/29/9532/479/5f583e8fE3cfa1ff6/d5eca57a0a88c830.png") no-repeat center;
            background-size: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?72b30caa